import styled from "styled-components";

export const Title = styled.h5`
  font-size: 16px;
  line-height: 20px;
  font-family: ThemeFontRegular;
  font-weight: bold;
  color: ${({ theme }) => theme.customTheme.palette.Title.color};
  margin-bottom: ${({ theme }) => theme.customTheme.pxToRem(12)};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(28)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(36)};
  }
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 20px;
  gap: 32px;
  background: ${({ theme }) => theme.customTheme.palette.Steps.bgColor};
  border-radius: 12px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: ${({ theme }) => theme.customTheme.pxToRem(32)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  }
`;

export const StepIcon = styled.img`
  max-width: 48px;
  max-height: 48px;
`;

export const Step = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    align-items: center;
  }
`;

export const StepText = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-family: ThemeFontRegular;
  color: ${({ theme }) => theme.customTheme.palette.StepText.color};
  margin-bottom: 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  }
`;
